// extracted by mini-css-extract-plugin
export var circle = "ChatBotComponent-module--circle--3HM3O";
export var fab = "ChatBotComponent-module--fab--DXka6";